import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, withRouter } from 'react-router-dom'
import styles from './material-tabs.styl'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { CONFIGURATION_KEYS } from '../../../constants/enums'

const enhance = compose(
  withRouter,
  apiConfiguration({getValue: CONFIGURATION_KEYS.isBadgesEnabled.id}),
  connect(({ apiV2 }) => ({
    configuration: apiV2.configuration
  }))
)
class MaterialTabs extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    root: PropTypes.string,
    location: PropTypes.object,
    configuration: PropTypes.object
  }

  static defaultProps = {
    root: ''
  }

  render() {
    const { items, root, location, configuration } = this.props

    const filteredLinks = items.filter(link => {
      if (link.configs) {
        return link.configs.some(item => {
          return get(configuration,`values[${item}].booleanValue`)
        })
      }

      return link
    })

    return (
      <div className={styles.wrap}>
        {filteredLinks && filteredLinks.map(item => {
          const itemUrl = `${root}/${item.to}`
          const activeClass = (itemUrl === location.pathname)
            ? styles.active
            : ''

          return (
            <Link
              key={item.id}
              to={`${root}/${item.to}`}
              className={`${styles.tab} ${activeClass}`}
            >
              <FormattedMessage id={item.intlKey} defaultMessage={item.label} />
            </Link>
          )
        })}
      </div>
    )
  }
}
export default enhance(MaterialTabs)

